const DeleteJutgePracticaFile = async (idPrac: string, idUser: string, uid: string) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}:8061/jutge/practica/${idPrac}/usuaris/${idUser}/upload/${uid}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response;
    } catch (error) {
        console.error('Error deleting file:', error);
        throw error;
    }
}
export { DeleteJutgePracticaFile };
